import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { DashboardShell } from "@/components/dashboard/DashboardShell";
import { ProfileView } from "@/components/dashboard/ProfileView";
import { AdvisorCard } from "@/components/dashboard/AdvisorCard";
import { LevelBadge } from "@/components/LevelBadge";
import { LayoutDashboard, Compass, MessageSquareText, GraduationCap, Briefcase, Sparkles, Loader2, ClipboardList, Star, ListChecks, Lightbulb, HelpCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export const STUDENT_NAV = [
  { to: "/app/student", label: "My TSB", icon: LayoutDashboard },
  { to: "/app/student/employment-profile", label: "Employment Report", icon: Briefcase },
  { to: "/app/student/whatif", label: "What-if & Careers", icon: Compass },
  { to: "/app/student/interests", label: "Career Interests", icon: Star },
  { to: "/app/student/academy", label: "Learning Academy", icon: GraduationCap },
  { to: "/app/student/jobs", label: "Jobs", icon: Briefcase },
  { to: "/app/student/advisor-updates", label: "Advisor Updates", icon: ClipboardList },
  { to: "/app/student/coach", label: "AI Skills Coach", icon: MessageSquareText },
  { to: "/app/tasks", label: "My Tasks", icon: ListChecks },
  { to: "/app/suggestions", label: "Submit a Suggestion", icon: Lightbulb },
  { to: "/app/help", label: "Help & Documentation", icon: HelpCircle },
];

export default function StudentHome() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/student/me").then(({ data }) => setData(data)).catch((e) => setErr(e.message));
  }, []);

  return (
    <DashboardShell title={data ? `Hi, ${data.name.split(" ")[0]}` : "My Benchmark"}
      subtitle={data ? `${data.program?.name} · Transferable Skills Benchmark` : "Loading your profile"}
      nav={STUDENT_NAV}>
      {!data && !err && <div className="flex h-64 items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-[#003057]" /></div>}
      {err && <p className="text-red-600">{err}</p>}
      {data && (
        <>
          {data.persona_title && (
            <div className="mb-5 flex flex-wrap items-center gap-3 rounded-2xl border-l-4 bg-white p-4 card-elevate"
              style={{ borderColor: data.color }} data-testid="student-persona">
              <span className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-sm font-bold text-white" style={{ backgroundColor: data.color }}>
                <Sparkles className="h-4 w-4" /> {data.persona_title}
              </span>
              <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-600">{data.personality}</span>
              <span className="text-xs font-semibold text-slate-400">Degree plan: <span className="text-[#003057]">{data.program?.name}</span></span>
              {data.narrative && <p className="w-full text-sm text-slate-600">{data.narrative}</p>}
            </div>
          )}
          <AdvisorCard />
          <div className="mb-6 flex flex-wrap gap-3">
            <Link to="/app/student/employment-profile"><Button className="rounded-full font-semibold text-white hover:opacity-90" style={{ backgroundColor: data.color }} data-testid="goto-employment">View Employment Report →</Button></Link>
            <Link to="/app/student/whatif"><Button className="rounded-full bg-[#78be21] font-semibold text-[#00243f] hover:bg-[#6aac1c]" data-testid="goto-whatif">Run a what-if scenario</Button></Link>
            <Link to="/app/student/coach"><Button variant="outline" className="rounded-full font-semibold" data-testid="goto-coach">Ask the AI Skills Coach</Button></Link>
          </div>
          <ProfileView data={data} showInterestProfile />
        </>
      )}
    </DashboardShell>
  );
}
